import React from "react";
import "./index.css";
import App from "./App";
import ReactDOM from "react-dom/client";
import swDev from "./swDev.js";

import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: 1.0,
});
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
swDev();
